module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/call-ad9bfb445838c718ca1b30cbc50c2219.svg";